import { useState } from 'react';
import type { SupportedModules } from '../providers/FeatureFlag.provider';

type ReturnTuple = [SupportedModules, (requestParams: SupportedModules) => void];
function useOpenModule(): ReturnTuple {
  const [openModule, setOpenModule] = useState<SupportedModules>('dashboard');
  return [
    openModule,
    (requestParams: SupportedModules) => {
      setOpenModule(requestParams);
    },
  ];
}

export default useOpenModule;
